<nav class="d-flex main-nav">
    <div class="logo col"><a href="https://flexcutech.com/"><img src="images/logo.png" alt="FLEXX logo" class="logo-img"></a></div>
    <div *ngIf="isSignedIn | async" class="text-light col-6 text-right header-btns">
        <button mat-stroked-button (click)="goTo('user')" *ngIf="loginService.getActiveUserSubject()
        | async as activeUser">Welcome, {{activeUser.firstName}} {{activeUser.lastName}}
            <i class="fas fa-cog header-cog"></i></button>
        <button mat-stroked-button>Client Home</button>
        <button mat-stroked-button (click)="loginService.signout()">Sign Out</button>
    </div>
</nav>
<nav *ngIf="isSignedIn | async" class="d-flex bg-light">
    <div class="col d-flex header-btns text-center sub-nav">
        <button *ngFor="let button of buttons | navFilter:loginService.activeUser" class="col" mat-stroked-button
                [ngClass]="{active: active === button.value}" (click)="goTo(button.value)">{{button.label}}</button>
    </div>
</nav>
